export default {
  'pages:subscription-confirmation:page-title': 'Anmeldung bestätigen',
  'pages:subscription-confirmation:header': 'Bitte warte einen Moment...',
};
